import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import  type{ RevaluationModels } from './RevaluationModels';
import type { APIResponse } from '../../../Shared/shared';

export const addRevaluation = createAsyncThunk(
  'Revaluation/addRevaluation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/AddFaRevaluationTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateRevaluation = createAsyncThunk(
  'Revaluation/updateRevaluation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/UpdateFaRevaluationTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRevaluationList = createAsyncThunk(
  'Revaluation/getRevaluationList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<RevaluationModels[]>>(
        'FATransaction/GetRevaluationList'
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getRevaluationById = createAsyncThunk(
  'Revaluation/getRevaluationById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<RevaluationModels>>(
        `FATransaction/GetRevaluationById?Id=${id}`
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getDepreciationByAssetId = createAsyncThunk(
//   'Depreciation/getDepreciationByAssetId',
//   async (AssetId: string, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.get<APIResponse<DepreciationModels>>(`FA/GetDepreciationByAssetId?AssetId=${AssetId}`);
//       if (data?.succeeded) {
//         return data?.data;
//       } else {
//         return rejectWithValue(data.message);
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState: {
  RevaluationList: RevaluationModels[];
  RevaluationById: RevaluationModels;
  // RevaluationByAssetId: RevaluationModels;
  loading: boolean;
  error: any | null;
} = {
  RevaluationList: [],
  RevaluationById: {} as RevaluationModels,
  // RevaluationByAssetId: {} as RevaluationModels,
  loading: false,
  error: null
};

const RevaluationSlice = createSlice({
  name: 'Revaluation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getRevaluationList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getRevaluationList.fulfilled,
        (state, action: PayloadAction<RevaluationModels[]>) => {
          state.loading = false;
          state.RevaluationList = action.payload;
        }
      )
      .addCase(getRevaluationList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      ////////////////////////////////////////////////////////////////
      .addCase(getRevaluationById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRevaluationById.fulfilled, (state, action: PayloadAction<RevaluationModels>) => {
        state.loading = false;
        state.RevaluationById = action.payload;
      })
      .addCase(getRevaluationById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getDepreciationByAssetId.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getDepreciationByAssetId.fulfilled, (state, action: PayloadAction<DepreciationModels>) => {
    //   state.loading = false;
    //   state.DepreciationByAssetId = action.payload;
    // })
    // .addCase(getDepreciationByAssetId.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // })
  }
});

export default RevaluationSlice.reducer;
